import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  gunguScrollPosition: 0,
};

const reducers = {
  setGunguScrollPosition(state, action) {
    state.gunguScrollPosition = action.payload;
  },
};

export const slice = createSlice({
  name: "gungu-scroll",
  initialState,
  reducers,
});

export const { reducer } = slice;
